/* ============================================================
   แปลงเมนูใน nav.js ให้เป็น "กลุ่มงาน" สำหรับเมนูแบบการ์ด (tiles)

   nav.js เก็บเมนูเป็นรายการเรียงกัน โดยมีรายการที่เป็น type: "group"
   คั่นเป็นหัวข้อกลุ่ม — ที่นี่จึงรวมเมนูที่อยู่ใต้หัวข้อแต่ละอันเข้าด้วยกัน
============================================================ */
import nav from "../nav";
import { menuKeyByPath } from "../constant/menu";

/* รหัสย่อและชื่อภาษาอังกฤษของแต่ละกลุ่ม ใช้แสดงบนแถบกลุ่มงานด้านบน */
export const GROUP_META = {
  Home: { code: "HM", name: "Home" },
  "ERP Report": { code: "RP", name: "ERP Report" },
  "ERP System": { code: "ER", name: "ERP System" },
  "ERP Master": { code: "EM", name: "ERP Master" },
  "RD System": { code: "RD", name: "RD System" },
  "RD Master": { code: "RM", name: "RD Master" },
  Admin: { code: "AD", name: "Admin" },
};

export const groupKey = (title) =>
  String(title || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-");

/* คืนกลุ่มงานทั้งหมด — เมนูที่ไม่มีสิทธิ์จะติดธง allowed = false
   (แสดงเป็นปุ่มสีเทา กดไม่ได้ แทนการซ่อน) */
export const buildGroups = (canView) => {
  const allowed = (item) => {
    const key = menuKeyByPath(item?.to || "");
    return !key || typeof canView !== "function" || canView(key);
  };

  const groups = [];
  let current = null;

  nav.forEach((item) => {
    if (item?.type === "group") {
      const meta = GROUP_META[item.title] || {};
      current = {
        key: groupKey(item.title),
        title: item.title,
        code: meta.code || String(item.title || "").slice(0, 2).toUpperCase(),
        name: meta.name || item.title,
        items: [],
      };
      groups.push(current);
      return;
    }
    if (!item?.to) return;
    if (!current) {
      current = { key: "other", title: "อื่นๆ", code: "OT", name: "Other", items: [] };
      groups.push(current);
    }
    current.items.push({ ...item, allowed: allowed(item) });
  });

  /* เรียงให้รายการที่มีสิทธิ์ใช้งานอยู่ข้างหน้าเสมอ (ของที่สิทธิ์เท่ากันคงลำดับเดิม) */
  const allowedFirst = (list) => [
    ...list.filter((i) => i.allowed),
    ...list.filter((i) => !i.allowed),
  ];

  return groups
    .filter((g) => g.items.length > 0)
    .map((g) => ({
      ...g,
      items: allowedFirst(g.items),
      allowedCount: g.items.filter((i) => i.allowed).length,
      allowed: g.items.some((i) => i.allowed),
    }))
    .sort((a, b) => Number(b.allowed) - Number(a.allowed));
};

/* หากลุ่มที่เป็นเจ้าของ path ปัจจุบัน ใช้ไฮไลต์แถบกลุ่มงานด้านบน */
export const findGroupByPath = (groups, pathname) => {
  let hit = null;
  let len = -1;
  (groups || []).forEach((g) =>
    g.items.forEach((it) => {
      if (it.to && pathname.startsWith(it.to) && it.to.length > len) {
        len = it.to.length;
        hit = g;
      }
    })
  );
  return hit;
};
